export default __webpack_public_path__ + "static/media/logo-300w.df81c593.png";